/* CUSTOM JAVASCRIPT FILE FOR EVERY PAGE
* 
* AOS Animation
* Search Bar Collapse
* Mobile Navigation behavior & Bootstrap formatting
*/

(function ($) {
  $(document).ready(function () {
    // Initialize AOS
    AOS.init({
      disable: "phone",
      disable: window.matchMedia("(prefers-reduced-motion: reduce)"),
      offset: 120,
      delay: 0,
      duration: 600,
      easing: "ease-in-out",
      once: true,
      mirror: false,
      anchorPlacement: "top-bottom",
    });



    // Focus on search input when its container is shown
    $("#searchCollapse").on("shown.bs.collapse", function () {
      $(this).find('input[type="search"]').focus();
    });

    // Directly target dropdown items within #menu-main-offcanvas
    const $menuMainOffcanvas = $("#menu-main-offcanvas");
    $menuMainOffcanvas.on("click", ".dropdown-item", function (e) {
      const $submenu = $(this).next(".dropdown-menu");
      if (
        $(this).attr("href").trim() !== "#" &&
        $(this).attr("href").trim() !== ""
      ) {
        return; // Allow the default behavior for the anchor containing a URL
      }
      if ($submenu.length) {
        e.preventDefault(); // Prevent the link from navigating
        e.stopPropagation(); // Stop the click from closing the entire dropdown

        // Toggle the immediate submenu
        $submenu.toggleClass("show");

        // Update aria-expanded attribute based on submenu visibility
        const isExpanded = $submenu.hasClass("show");
        $(this).attr("aria-expanded", isExpanded);

        // Optional: Close other submenus at the same level except for the current one
        $(this)
          .parent()
          .siblings()
          .find(".dropdown-menu.show")
          .removeClass("show")
          .prev(".dropdown-item")
          .attr("aria-expanded", false); // Ensure siblings' aria-expanded attributes are correctly set

        return false; // Ensure no further processing for this event
      }
      // For items without a submenu, allow default behavior
    });

    // Close submenus when clicking outside within #menu-main-offcanvas
    $(document).on("click", function (e) {
      if (!$(e.target).closest("#menu-main-offcanvas").length) {
        $menuMainOffcanvas.find(".dropdown-menu.show")
          .removeClass("show")
          .prev(".dropdown-item")
          .attr("aria-expanded", false); // Update aria-expanded for items when closing submenu by clicking outside
      }
    });

    // Ensure Bootstrap's dropdowns close all submenus on main dropdown close within #menu-main-offcanvas
    $menuMainOffcanvas.on("hidden.bs.dropdown", function () {
      $(this)
        .find(".dropdown-menu.show")
        .removeClass("show")
        .prev(".dropdown-item")
        .attr("aria-expanded", false); // Ensure aria-expanded is reset on all items when the dropdown is fully closed
    });
  });

  
})(jQuery);
